export default {"version": "1.47-1169-g6a590691"}
